// action types
export const NEW_TEXT = 'NEW_TEXT'
export const SET_HOVER = 'SET_HOVER'
export const TICK = 'TICK'
export const SET_COLOR = 'SET_COLOR'
export const INCREMENT_RENDER_COUNT = 'INCREMENT_RENDER_COUNT'
export const SELECT_THEME = 'SELECT_THEME'



// WEBPACK FOOTER //
// ./src/redux/constants.js